/* typewriter.ro — RO/EN switch, mobile menu, waveforms */
(function () {
  var KEY = 'tw-lang';
  function get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function apply(l) {
    document.documentElement.lang = l;
    document.querySelectorAll('[data-en]').forEach(function (el) {
      if (!el.hasAttribute('data-ro')) el.setAttribute('data-ro', el.innerHTML);
      el.innerHTML = l === 'en' ? el.getAttribute('data-en') : el.getAttribute('data-ro');
    });
    document.querySelectorAll('[data-en-ph]').forEach(function (el) {
      if (!el.hasAttribute('data-ro-ph')) el.setAttribute('data-ro-ph', el.getAttribute('placeholder') || '');
      el.setAttribute('placeholder', l === 'en' ? el.getAttribute('data-en-ph') : el.getAttribute('data-ro-ph'));
    });
    document.querySelectorAll('[data-lang]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-lang') === l)); });
  }
  var nav = (navigator.language || 'ro').slice(0, 2).toLowerCase();
  var lang = get() || (nav === 'ro' ? 'ro' : 'en');
  apply(lang);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lang]');
    if (b) { lang = b.getAttribute('data-lang'); set(lang); apply(lang); return; }
    var c = e.target.closest('[data-cookie-prefs]');
    if (c) {
      e.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); }
      else { location.href = '/policies/privacy-policy#cookies'; }
      return;
    }
    var m = e.target.closest('[data-menu]');
    if (m) {
      var p = document.getElementById('twMnav');
      var open = p.classList.toggle('open');
      m.setAttribute('aria-expanded', String(open));
    }
  });

  document.querySelectorAll('[data-wave]').forEach(function (w, n) {
    var s = '', seed = Number(w.getAttribute('data-wave')) || n + 1;
    for (var i = 0; i < 64; i++) {
      var h = 5 + Math.round(Math.abs(Math.sin(i * 0.9 * seed) * Math.cos(i * 0.23 + seed)) * 24);
      s += '<i style="height:' + h + 'px"></i>';
    }
    w.innerHTML = s;
  });
})();
